import React, { useState, useEffect } from 'react';
import axios from 'axios';
const BE_API_URL = process.env.REACT_APP_BACKEND_API_URL;

const ExtractSeoFromUrl = () => {
  const [url, setUrl] = useState('');
  const [seoInfo, setSeoInfo] = useState(null);
  const [error, setError] = useState('');

  const handleFetchSEOInfo = async () => {
    try {
      axios.post(`${BE_API_URL}/api/getSeoinformation`, {
        url
      })
      .then(function (response) {
        if (response.data.status) {
          setSeoInfo(response.data.result);
        } else {
          setError('Failed to fetch SEO information. Make sure the URL is valid and accessible.');
        }
      })
      .catch(function (error) {
        console.log(error);
      });
      setError('');
    } catch (err) {
      setError('Failed to fetch SEO information. Make sure the URL is valid and accessible.');
    }
  };

  const snakeToTitleCase = (snakeStr) => {
    return snakeStr
      .split('_') // Split on underscores
      .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
      .join(' '); // Join the words with spaces
  }

  const camelToTitleCase = (camelStr) => {
    return camelStr
      .replace(/([A-Z])/g, ' $1') // Add a space before each uppercase letter
      .replace(/^./, str => str.toUpperCase()) // Capitalize the first letter of the string
      .trim(); // Remove any leading or trailing spaces
  }
  
  const renderError = () => {
    return (
      <>
        <div
          className="flex mt-4 p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400"
          role="alert"
        >
          <svg
            className="flex-shrink-0 inline w-4 h-4 me-3 mt-[2px]"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z" />
          </svg>
          <span className="sr-only">Danger</span>
          <div>
            <span className="font-medium">
             Something went wrong:
            </span>
            <ul className="mt-1.5 list-disc list-inside">
              <li>{error}</li>
            </ul>
          </div>
        </div>
      </>
    )
  }

  useEffect(() => {
    if (url) {
      handleFetchSEOInfo()
    } else {
      setSeoInfo(null)
    }
  },[url])

  return (
    <div className="grid grid-cols-1 xl:grid-cols-1 xl:gap-4">
      <div className="grid grid-cols-2 bg-white p-4 mb-4 space-y-6 border border-gray-200 rounded-lg shadow-sm 2xl:col-span-2 dark:border-gray-700 sm:p-6 dark:bg-gray-800">
        <div className='col-span-1 min-h-screen'>
          <div className="px-4 tex py-2 text-gray-400 rounded dark:border-gray-600">
            <input
              type="text"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              className="bg-gray-50 border w-full border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block  p-4 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              required={true}
              placeholder='Enter website URL'
            />
            { error && renderError() }
            {seoInfo && (
              <ul className="mt-4 space-y-4 text-left text-gray-700 dark:text-gray-200">
                { Object.keys(seoInfo).map((key) => {
                  return (
                    <li className="flex items-center space-x-3 rtl:space-x-reverse">
                      {/* <svg
                        className="flex-shrink-0 w-3.5 h-3.5 text-green-500 dark:text-green-400"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 16 12"
                      >
                        <path
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M1 5.917 5.724 10.5 15 1.5"
                        />
                      </svg> */}
                      <span><strong>{camelToTitleCase(key)}</strong> : {seoInfo[key]}</span>
                    </li>
                  )
                }) }
              </ul>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ExtractSeoFromUrl;
